<template>
  <div>
    <div class="login" v-if="notExist">
      <label class="login">该序列号不存在！</label><br><br>
      <a-button type='primary' @click="back">确定</a-button>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="APPKey：" disabled = "true" default-value="" v-model="APPKey"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="APPSecret：" disabled = "true" default-value="" v-model="APPSecret"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="DeviceType：" disabled = "true"  default-value="" v-model="DeviceType"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="DeviceID：" disabled = "true" default-value="" v-model="DeviceID"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="用户："  default-value="" v-model="user"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="位置："  default-value="" v-model="location"/>
    </div>
    <div class="login" v-if="Exist">
      <a-input addon-before="截止日期："  default-value=""  v-model="deadline"/>
    </div>
    <div class="login" v-if="Exist">
      <a-button type='primary' @click="submit">确定</a-button>
    </div>
    <div class="login" v-if="Exist">
      <a-button type='primary' @click="asign">分配</a-button>
    </div>
    <div class="login" v-if="Exist">
      <a-button type='primary' @click="release">释放</a-button>
    </div>
  </div>

</template>
<script>
export default {
  data(){
    return {
      user:"",
      SN:"",
      APPKey:"",
      APPSecret:"",
      DeviceType:"",
      DeviceID:"",
      creator:"",
      location:"",
      deadline:"",
      notExist:false,
      Exist:false
    }
  },
  created()
  {
    let sn = this.$store.state.terminalid; 
    if(sn.length > 0){
    let param = {
        SN:sn
    }
    let obj = this.$qs.stringify(param)
    this.$axios({
      method:'post',
      url:'/api/terminal/query',
      data: obj
    }).then((response) =>{
            //这里使用了ES6的语法
      if(response.data.length>0){
        this.Exist = true
        this.notExist = false
      let result = response.data[0]
      this.user = result["user"];
      this.SN = result["sn"];
      this.APPKey = result["appkey"];
      this.APPSecret = result["appsecret"];
      this.DeviceType = result["devicetype"];
      this.DeviceID = result["deviceid"];
      this.creator = result["creator"];
      this.location = result["location"];
      this.deadline = result["activatetime"]
       console.log(response)       //请求成功返回的数据
      }
      else{
        this.Exist = false
        this.notExist = true
        console.log("not exist!")
      }
    }).catch((error) =>{

      console.log(error)       //请求失败返回的数据
    })
    }
  },
    methods:{
        back(){
          this.$router.push('/home/terminallist')
        },
        submit (){
            let param = {
              user:this.user,
              SN:this.SN,
              location:this.location,
              DeviceID:this.DeviceID,
              DeviceType:this.DeviceType,
              APPKey:this.APPKey,
              APPSecret:this.APPSecret,
              creator:'admin'
            }
            let obj = this.$qs.stringify(param)
            if(this.SN=="")
            {
              alert("请完善信息！")
            }
            else
            {
              let sn = this.$store.state.terminalid;
              if(sn.length>0){

                this.$axios({
                method:'post',
                url:'/api/terminal/update',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              let result = response.data
              if(result["result"])
              {
                this.$store.state.terminalid=""
                this.$router.push('/home/terminallist')
              }

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据

      })
              }
              else
              {
                this.$axios({
                method:'post',
                url:'/api/terminal/regist',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              let result = response.data
              if(result["result"])
              {
                this.$store.state.terminalid=""
                this.$router.push('/home/terminallist')
              }

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据

      })}

            }

        },
        asign(){
          //TODO
          if(!isValidDateFormat(this.deadline))
          {
            alert("请输入正确的日期！！")
            return
          }
          let param = {
              SN:this.SN,
              deadline:this.deadline
            }
            let obj = this.$qs.stringify(param)
          this.$axios({
                method:'post',
                url:'/api/terminal/asign',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              if(response.data.length>0){
              let result = response.data[0]
              this.user = result["user"];
              this.SN = result["sn"];
              this.APPKey = result["appkey"];
              this.APPSecret = result["appsecret"];
              this.DeviceType = result["devicetype"];
              this.DeviceID = result["deviceid"];
              this.creator = result["creator"];
              this.location = result["location"];
              this.deadline = result["activatetime"]
              console.log(response)       //请求成功返回的数据
            }      //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
      })
        },
        release(){
          //TODO
          let param = {
              SN:this.SN,
            }
          let obj = this.$qs.stringify(param)
          this.$axios({
                method:'post',
                url:'/api/terminal/release',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              if(response.data.length>0){
        
              let result = response.data[0]
              this.user = result["user"];
              this.SN = result["sn"];
              this.APPKey = result["appkey"];
              this.APPSecret = result["appsecret"];
              this.DeviceType = result["devicetype"];
              this.DeviceID = result["deviceid"];
              this.creator = result["creator"];
              this.location = result["location"];
              this.deadline = result["activatetime"]
              console.log(response)       //请求成功返回的数据
            } 

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
      })
        }
    }
}
function isValidDateFormat(dateString) {
  const regex = /^\d{4}\d{2}\d{2}$/;
    // 检查字符串是否符合格式
    if (!regex.test(dateString)) 
      return false;
    return true;
}
</script>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.login {
  margin-top:20px;
  margin-left:auto;
  margin-right:auto;
  width:300px

}
</style>


// WEBPACK FOOTER //
// src/components/NewTerminal.vue